import React, { lazy } from 'react';
import { ShieldAlert, CheckCircle2, ChevronRight, Wrench } from 'lucide-react';
export function SideRearGlass() {
  const commonDamage = ['Driver side window shattered', 'Passenger side window broken', 'Rear window shattered', 'Car door glass broken', 'Quarter glass damage', 'Truck rear glass broken', 'Van or fleet vehicle glass damage'];
  const kosinsConfirms = ['Vehicle year, make and model', 'Which glass is broken', 'Whether power-window parts are involved', 'Glass availability', 'Insurance details', 'Appointment availability', 'Drop-off or service options'];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1131">
      <div className="max-w-7xl mx-auto" data-id="element-1132">
        {/* Image + intro */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-14" data-id="element-1133">
          <div data-id="element-1134">
            <div className="inline-flex items-center gap-2 bg-emergencyBrand-redLight text-emergencyBrand-red px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-5 border border-emergencyBrand-redBorder" data-id="element-1135">
              <span className="w-1.5 h-1.5 rounded-full bg-emergencyBrand-red" data-id="element-1136" />
              Side &amp; Rear Glass
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-5 tracking-tight leading-tight" data-id="element-1137">
              <span className="text-emergencyBrand-red" data-id="element-1138">
                Side Window Shattered?
              </span>{' '}
              Rear Window Broken?
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-1139">
              Broken side or rear vehicle glass can expose your vehicle to
              weather, theft risk and safety concerns. Kosin's Glass replaces
              side windows, power window glass, car door glass, quarter glass
              and rear windows for many vehicle types.
            </p>
          </div>
          <div className="relative" data-id="element-1140">
            <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200 aspect-[4/3]" data-id="element-1141">
              <img src="https://cdn.magicpatterns.com/uploads/fyQT9E9St2wsFmTknUbmfv/%E2%80%9CSide_Window_Shattere.png" alt="Auto glass technician removing a shattered side window from a vehicle as part of an emergency side window replacement" className="w-full h-full object-cover" loading="lazy" data-id="element-1142" />
            </div>
            <div className="hidden sm:flex absolute -bottom-5 -left-5 bg-white border border-slate-200 shadow-md rounded-xl px-4 py-3 items-center gap-3" data-id="element-1143">
              <div className="bg-emergencyBrand-redLight p-2 rounded-lg" data-id="element-1144">
                <Wrench className="w-5 h-5 text-emergencyBrand-red" data-id="element-1145" />
              </div>
              <div data-id="element-1146">
                <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide" data-id="element-1147">
                  On-Site Repair
                </div>
                <div className="text-sm font-bold text-slate-900" data-id="element-1148">
                  Side &amp; Rear Glass
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Two columns of bullets */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-1149">
          <div className="bg-slate-50 rounded-xl p-6 sm:p-8 border border-slate-200" data-id="element-1150">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2.5" data-id="element-1151">
              <ShieldAlert className="w-6 h-6 text-emergencyBrand-red" data-id="element-1152" />
              Common urgent glass damage
            </h3>
            <ul className="space-y-3" data-id="element-1153">
              {commonDamage.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-1154">
                  <ChevronRight className="w-5 h-5 text-emergencyBrand-red shrink-0 mt-0.5" data-id="element-1155" />
                  <span className="text-slate-700" data-id="element-1156">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-slate-50 rounded-xl p-6 sm:p-8 border border-slate-200" data-id="element-1157">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2.5" data-id="element-1158">
              <CheckCircle2 className="w-6 h-6 text-emergencyBrand-red" data-id="element-1159" />
              What Kosin's will confirm
            </h3>
            <ul className="space-y-3" data-id="element-1160">
              {kosinsConfirms.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-1161">
                  <span className="shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 border-emergencyBrand-red flex items-center justify-center" data-id="element-1162">
                    <CheckCircle2 className="w-3 h-3 text-emergencyBrand-red" strokeWidth={3} data-id="element-1163" />
                  </span>
                  <span className="text-slate-700" data-id="element-1164">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="text-center" data-id="element-1165">
          <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-1166">
            Get a Side or Rear Window Quote
          </a>
        </div>
      </div>
    </section>;
}